// extracted by mini-css-extract-plugin
export default {"section":"MacronutrientBalancePage_section__OOeHb","imgMain":"MacronutrientBalancePage_imgMain__DtTKw"};